import { IllustrationJsonldIllustrationRead, RarityCardDetailRead } from '@/api/generated';
import { ILLUSTRATION_TYPE_API_REF } from '@/types/modifiers/references';

export type SortedIllustrationType = {
  [key: string]: IllustrationJsonldIllustrationRead[];
};

const sortByFaction = (data: IllustrationJsonldIllustrationRead[] | undefined): SortedIllustrationType | undefined =>
  data &&
  data.reduce((acc: SortedIllustrationType, curr: IllustrationJsonldIllustrationRead) => {
    if (!curr.factions || !curr.factions[0]) {
      return acc;
    }
    const currentFaction = curr.factions[0].name || curr.factions[0].reference;
    if (acc[currentFaction]) {
      acc[currentFaction].push(curr);
    } else {
      acc[currentFaction] = [curr];
    }

    return acc;
  }, {});

export default sortByFaction;

const getWebAssetRarityIndex = (rarity?: RarityCardDetailRead['reference']) => {
  switch (rarity) {
    case 'UNIQUE':
      return 2;
    case 'RARE':
      return 1;
    case 'COMMON':
    default:
      return 0;
  }
};

export const getCardWebAssetByRarity = (
  assets?: Record<string, string | string[]>,
  rarity?: RarityCardDetailRead['reference'],
) => {
  const asset = assets?.[ILLUSTRATION_TYPE_API_REF.WEB]?.[getWebAssetRarityIndex(rarity)];

  return asset;
};
